import { ContactsView } from '@/components/contacts/contacts-view'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/dashboard_/contacts')({
  component: RouteComponent,
  beforeLoad: ({ context: { user } }) => {
    if (user?.isAdmin) throw redirect({ to: '/sign-out' })
    return { breadcrumb: 'Contacts', user }
  },
  loader: async ({ context: { orpc, queryClient, user } }) => {
    await queryClient.ensureQueryData(
      orpc.backoffice.contacts.getAll.queryOptions({
        input: { villageId: user!.village!.id }
      })
    )
  }
})

function RouteComponent() {
  const { user, orpc } = Route.useRouteContext()

  return <ContactsView user={user} orpc={orpc} />
}
